export const REFUND_DRAWER = 'refund-drawer';
export const REFUND_DRAWER_VIEW_TXN_DETAIL_BUTTON = 'refund-drawer-view-txn-detail-button';
export const REFUND_HISTORY_BUTTON = 'refund-history-button';
export const REFUND_CARD_REF_COPY_ICON = 'copy-refundId';
export const REFUND_CARD_UTR_COPY_ICON = 'copy-utr';
export const REFUND_CARD_MERCHANT_ID_COPY_ICON = 'copy-merchantOrderId';
export const REFUND_CARD_NOTE_COPY_ICON = 'copy-note';
export const REFUND_BADGE_ICON = 'refund-badge-icon';
export const REFUND_SIDE_DRAWER_CARD = 'refund-card';
export const REFUND_SIDE_DRAWER_NEED_HELP_BUTTON = 'refund-drawer-help-button';
export const REFUND_DRAWER_LOADER = 'refund-drawer-loader';
